import React from 'react';
import SendMessage  from './SendMessage';
import SendFollowRequest  from './SendFollowRequest';
import SendFriendRequest  from './SendFriendRequest';
import iconPath from "./../../../helpers/iconHelper";
import ProfileImageUpload from "./ProfileImageUpload";

const UserHeader = (props) => { 
    
    const {id, is_friend, users_profile_image , full_name, city, country_name,membership, is_following } = props.user;
    let isfollowing = 0;
    
    if(Object.keys(props.unfriendrequest).length > 0){
        isfollowing = 0;
    }else if(Object.keys(props.respondtorequest).length > 0){
        isfollowing = props.respondtorequest.status == 'ACCEPTED' ? 1 : 0;
    }else{
        isfollowing = is_following
    }
    
    return (
        <div className="cover_pic">
            {
                (users_profile_image != '') ? 
                <img className={(membership == 'GOLD') ? "user gold_user" : "user"} src={users_profile_image} id="profile-img"/> : 
                <img className={(membership == 'GOLD') ? "user gold_user" : "user"} src={iconPath['DEFAULTUSER']} id="profile-img"/>
            }
            
            {(props.ownProfile != false) ? 
                <ProfileImageUpload />
                : null
            }
            <h2>{full_name} </h2>
            <span>{city}, {country_name}</span>
            {(props.ownProfile == false) ? 
                <ul>
                    
                    <SendFriendRequest friendId={id} is_friend={is_friend}/>
                    <SendFollowRequest friendId={id} is_following={isfollowing} respondtorequest={ props.respondtorequest}/>
                    <SendMessage friendId={id}/>
                </ul>
                : <ul>
                    
                  </ul>
            }


           
        </div>
    );
}

export default UserHeader;